import { Address, Partner } from "@/types/partner";

export function mapPartners(partners: Partner[]) {
  const result: {[partnerId: string]: Partner} = {}
  for (let i = 0; i < partners.length; i++) {
    result[partners[i].id] = partners[i]
  }
  return result
}
export function classifyPartners(partners: Partner[], partnerId: string|undefined, partnerOnly: boolean,
  orderedPartnersId: string[],
  classifiedPartners: { [countryCode: string]: {[area: string] : {[city: string] : {[partnerId: string]: Address[]}}}}): void {
  
  const partnersId = []
  for (let i = 0; i < partners.length; i++) {
    const partner = partners[i];
    const id = partner.id
    if(partnerOnly && partnerId && partnerId !== id) continue
    partnersId.push(id)
    for(let j = 0; j < (partner.addresses.length || 0); j++) {
      const address = partner.addresses[j]
      let countryLevel = classifiedPartners[address.countryCode]
      if(!countryLevel) {
        countryLevel = {}
        classifiedPartners[address.countryCode] = countryLevel
      }
      const area = address.area
      let areaLevel = countryLevel[area]
      if(!areaLevel) {
        areaLevel = {}
        countryLevel[area] = areaLevel
      }
      let cityLevel = areaLevel[address.city]
      if(!cityLevel) {
        cityLevel = {}
        areaLevel[address.city] = cityLevel
      }
      let partnerLevel = cityLevel[id]
      if(!partnerLevel) {
        partnerLevel = []
        cityLevel[id] = partnerLevel
      }
      partnerLevel.push(address)
    }
  }
  // Shuffle partners
  orderedPartnersId.push(...partnersId.sort((p1, p2) => {
    if(p1 === partnerId) return -1
    if(p2 === partnerId) return 1
    return Math.random() - 0.5
  }))
}